import { FileUpload } from "@/components/ui/file-upload";
import { TypographyH3, TypographyLarge } from "@/components/ui/typography";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

type UploadStepProps = {
  file: File | null;
  onFileChange: (file: File | null) => void;
};

export default function UploadStep({ file, onFileChange }: UploadStepProps) {
  const { t } = useTranslation();
  return (
    <div className="w-full h-[350px]">
      <TypographyH3 className="mb-2">
        {t("transactions.file_import.upload_label")}
      </TypographyH3>
      <p className="text-sm text-gray-600 mb-4 font-medium">
        {t("transactions.file_import.guidance_upload")}
      </p>
      <FileUpload
        label={t("transactions.file_import.select_exported_csv")}
        accept=".csv,text/csv,application/vnd.ms-excel"
        value={file}
        takesFullHeight={!file}
        onChange={onFileChange}
      />
      {file && (
        <div className="flex items-center justify-center w-full h-20">
          <Loader2 className="w-8 h-8 animate-spin mr-2 text-gray-700" />
          <TypographyLarge className="text-gray-700">
            {t("transactions.file_import.importing_file")}
          </TypographyLarge>
        </div>
      )}
    </div>
  );
}
